export type MaskedTemplate = {
  masked: string;
  placeholders: string[];
};

import { PLACEHOLDER_PATTERN } from '../../constants';

// Masks {{ }} placeholders so a template split cannot hit JSONata & / = operators.
export const maskPlaceholders = (template: string): MaskedTemplate => {
  const placeholders: string[] = [];
  const masked = template.replace(PLACEHOLDER_PATTERN, (match) => {
    placeholders.push(match);
    return `\u0000${placeholders.length - 1}\u0000`;
  });
  return { masked, placeholders };
};
